import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { DateTimeService } from '../../../../../core/services/date-time.service';
import { SmsBodyModule } from '../../../../../shared/components/sms-body/sms-body.module';
import {
  ComparisonOperator,
  CreateTextParserCommand,
  SendTypes,
  TextParserIfConditionType,
  UpdateTextParserCommand,
  UserPrivateNumbersForSendDto,
} from './../../../../../core/api/models';
import { TextParsersService } from './../../../../../core/api/services';
import { FormPageConfig } from './../../../../../core/models/form-page-config.model';
import { BaseFormPageComponent } from './../../../../../pages/shared/base/components/base-form-page.component';
import { PeriodicDateTimeConfig } from './../../../../../shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { TextParserIfConditionComponent } from './text-parser-if-condition/text-parser-if-condition.component';
import { TextParserThenConditionComponent } from './text-parser-then-condition/text-parser-then-condition.component';

@Component({
  selector: 'app-text-parser-form',
  templateUrl: './text-parser-form.component.html',
  styleUrls: ['./text-parser-form.component.scss'],
  imports: [
    BaseFormModule,
    TextParserThenConditionComponent,
    TextParserIfConditionComponent,
    SmsBodyModule,
  ],
})
export class TextParserFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  model: CreateTextParserCommand = {};

  formPageConfig: FormPageConfig<any> = {};

  thenConditionForms: FormGroup[] = [];

  periodicDateTimeConfig: PeriodicDateTimeConfig;

  get ComparisonOperator() {
    return ComparisonOperator;
  }

  get SendTypes() {
    return SendTypes;
  }

  isSuperAdmin: boolean;

  duplicateMessageResponse: string;

  //#endregion

  constructor(protected currentService: TextParsersService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.setComponentsConfig();
      this.duplicateMessageResponse = this.model.duplicateMessageResponse?.text;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  initModel() {
    try {
      this.model.formulas = [];
      this.model.duplicateMessageResponse = {};
      this.onAddFormul();
      super.initModel();
      if (this.formPageConfig.isEditMode) {
        this.model.privateNumberId =
          this.formPageConfig.editData.receiverPrivateNumber.id;
        this.model.privateNumberNumber =
          this.formPageConfig.editData.receiverPrivateNumber.number;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      privateNumberId: new FormControl('', Validators.required),
      isActive: new FormControl(''),
      isChildrenChange: new FormControl(''),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
      startTime: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required),
      senderConditionType: new FormControl(''),
      senderConditionValue: new FormControl(''),
      senderPhonebookId: new FormControl(''),
      text: new FormControl(
        ''
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters)
      ),
      privateNumber: new FormControl(''),
    });
  }

  setComponentsConfig() {
    try {
      this.periodicDateTimeConfig = {
        startDateLabel: 'common.startDay',
        startTimeLabel: 'common.startHour',
        endDateLabel: 'common.endDay',
        endTimeLabel: 'common.endHour',
        startDateFormControl: this.form?.get('startDate') as FormControl,
        startTimeFormControl: this.form?.get('startTime') as FormControl,
        endDateFormControl: this.form?.get('endDate') as FormControl,
        endTimeFormControl: this.form?.get('endTime') as FormControl,
        responsiveClassName: 'sm:tw-w-1/2 xl:tw-w-1/3 xl:tw-w-1/4',
        isEditMode: this.formPageConfig.isEditMode,
        minStartDateType: 'today',
      };
      let isValidStartDate = DateTimeService.isValidUtcDateTime(
        this.formPageConfig.editData.startDateTime
      );
      let isValidEndDate = DateTimeService.isValidUtcDateTime(
        this.formPageConfig.editData.endDateTime
      );

      if (this.formPageConfig.isEditMode) {
        this.periodicDateTimeConfig.startDateTimeValue = isValidStartDate
          ? this.formPageConfig.editData.startDateTime
          : '';
        this.periodicDateTimeConfig.endDateTimeValue = isValidEndDate
          ? this.formPageConfig.editData.endDateTime
          : '';
      } else {
        // this.periodicDateTimeConfig.startDateTimeValue = DateTimeService.getCurrentDateTime();
        this.periodicDateTimeConfig.endDateTimeValue =
          DateTimeService.getSomeDaysAfter(1);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#region formul

  onAddFormul() {
    try {
      this.model.formulas.push({
        ifConditionType: TextParserIfConditionType.All,
        ifConditionValue: '',
        thenConditionValue: '',
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onRemoveFormul(index: number) {
    try {
      this.model.formulas.splice(index, 1);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#endregion

  //#region api

  baseCreateApi(model: CreateTextParserCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .textParsersCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  baseUpdateApi(model: UpdateTextParserCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .textParsersUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSelectPrivateNumber(event: UserPrivateNumbersForSendDto) {
    try {
      this.model.privateNumberNumber = event.number;
      this.model.privateNumberId = event.id;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSubmit() {
    try {
      if (this.loading) return;

      if (!this.isValidForm(this.form, this.tagName)) return;

      if (!this.isValidThenConditionForms()) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  isValidThenConditionForms(): boolean {
    try {
      let result: boolean = true;

      this.thenConditionForms.forEach((form) => {
        if (form.invalid) {
          result = false;
          form.markAllAsTouched();
        }
      });

      return result;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetResponsePrivateNumber(event: UserPrivateNumbersForSendDto) {
    try {
      this.model.duplicateMessageResponse.privateNumber = {};
      this.model.duplicateMessageResponse.privateNumber.id = event.id;
      this.model.duplicateMessageResponse.privateNumber.number = event.number;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetResponseText(event: string) {
    try {
      this.model.duplicateMessageResponse.text = event;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onRefresh() {
    this.model = {};
    this.initModel();
    this.setComponentsConfig();
  }
}
